import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';
import { Field } from 'redux-form';
import { DatePickerField } from './DatePickerField';
import { SemanticFormField } from './SemanticFormField';
import { componentPool } from '../helpers/componentPool';
import { getValidations } from '../helpers/validationByFieldType';

// components

class FormSection extends PureComponent {
  static propTypes = {
    sections: PropTypes.object.isRequired,
    hexColorCodeC: PropTypes.string.isRequired,
    optionByField: PropTypes.object.isRequired,
    name: PropTypes.string.isRequired,
  };

  render() {
    const { sections, hexColorCodeC, optionByField, name } = this.props;
    return (
      <div>
        {sections[name] && (
          <h4
            style={{ color: `#${hexColorCodeC}` }}
            className="ui dividing header"
          >
            {name}
          </h4>
        )}
        {sections[name] &&
          Object.values(sections[name]).map((group, gi) => (
            <Form.Group key={gi} widths="equal">
              {group.map(
                (field, fi) =>
                  field.fieldTypeC === 'Date' ? (
                    <DatePickerField
                      key={fi}
                      name={field.sfId}
                      placeholder={field.name}
                      inputValueFormat="YYYY-MM-DD"
                      dateFormat="L"
                      placeholderText={field.name}
                      fixedHeight
                      showMonthDropdown
                      showYearDropdown
                      dropdownMode="select"
                      validate={getValidations(
                        field.requiredC,
                        field.validationTypeC
                      )}
                    />
                  ) : (
                    <Field
                      key={fi}
                      field={field}
                      name={field.sfId}
                      component={SemanticFormField}
                      as={componentPool[field.fieldTypeC]}
                      validate={getValidations(
                        field.requiredC,
                        field.validationTypeC
                      )}
                      options={optionByField[field.sfId]}
                      maxLength={field.characterLimitC}
                      labeled
                      selection
                      header={field.name}
                    />
                  )
              )}
            </Form.Group>
          ))}
      </div>
    );
  }
}

export default FormSection;



// WEBPACK FOOTER //
// ./src/components/FormSection.js